export default function WordsOnAThread() {
    window.location.replace('https://www.jeanninecharles.net/words-on-a-thread');
    return(null)
    //return(<h1>WordsOnAThread</h1>)
}